var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChartDonutDarkThemePc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 400C310.457 400 400 310.457 400 200C400 89.5431 310.457 0 200 0C89.5431 0 0 89.5431 0 200C0 310.457 89.5431 400 200 400ZM200 351C283.395 351 351 283.395 351 200C351 116.605 283.395 48.9998 200 48.9998C116.605 48.9998 48.9998 116.605 48.9998 200C48.9998 283.395 116.605 351 200 351Z",
    fill: "#424850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChartDonutDarkThemePc);
export default __webpack_public_path__ + "static/media/empty-chart-donut-dark-theme-pc.50940c5e2627a97ca94f548f4965ff89.svg";
export { ForwardRef as ReactComponent };